import React, { useState, useEffect } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { Radio, RadioGroup } from "@headlessui/react";
import { CheckCircleIcon } from "@heroicons/react/20/solid";

const monthlyMailingLists = [
  {
    id: 1,
    title: "Osnovni",
    tip: "Mesečno",
    brJelovnika: 8,
    description:
      "1. Sve računice BMI, BMR, TDEE... \n 2. Procene Vaših parametara \n3. Kompletni izveštaji za 3 i 7 dana \n4. 8 jelovnika mesečno \n5. Konsultacije sa nutricionistom (30 min mesečno)",
    users: "3000 RSD",
  },
  {
    id: 2,
    title: "Napredni",
    tip: "Mesečno",
    brJelovnika: 20,
    description:
      "1. Sve računice BMI, BMR, TDEE... \n 2. Procene Vaših parametara \n3. Kompletni izveštaji za 3 i 7 dana \n4. 20 jelovnika mesečno \n5. Konsultacije sa nutricionistom (30 min mesečno) \n6. Garancija povrata novca \n7. Planovi mršavljenja (umereno i agresivno)",
    users: "12000 RSD",
  },
];

const yearlyMailingLists = [
  {
    id: 1,
    title: "Osnovni",
    tip: "Godišnje",
    brJelovnika: 8,
    description:
      "1. Sve računice BMI, BMR, TDEE... \n 2. Procene Vaših parametara \n3. Kompletni izveštaji za 3 i 7 dana \n4. 8 jelovnika mesečno \n5. Konsultacije sa nutricionistom (30 min mesečno) \n6. Garancija povrata novca",
    users: "25000 RSD",
  },
  {
    id: 2,
    title: "Napredni",
    tip: "Godišnje",
    brJelovnika: 20,
    description:
      "1. Sve računice BMI, BMR, TDEE... \n 2. Procene Vaših parametara \n3. Kompletni izveštaji za 3 i 7 dana \n4. 20 jelovnika mesečno \n5. Konsultacije sa nutricionistom (30 min mesečno) \n6. Garancija povrata novca \n7. Planovi mršavljenja (umereno i agresivno)",
    users: "90000 RSD",
  },
];

export default function SubscriptionModal({ id, mail }) {
  const [addNewPretplataModal, setAddNewPretplataModal] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedMailingLists, setSelectedMailingLists] = useState(null);

  const getMailingLists = () => {
    return selectedOption === "Mesečni"
      ? monthlyMailingLists
      : yearlyMailingLists;
  };

  const handleClose = () => {
    setAddNewPretplataModal(false);
    setSelectedOption("");
    setSelectedMailingLists(null);
  };

  //   useEffect(() => {
  //     console.log("selectedMailingLists: ", selectedMailingLists, id, mail);
  //   }, [selectedMailingLists]);

  const addPaket = async () => {
    if (!selectedMailingLists) return;
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/add-paket`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            idUser: id,
            mail: mail,
            imePaketa: selectedMailingLists.title,
            brJelovnika: selectedMailingLists.brJelovnika,
            tipPaketa: selectedMailingLists.tip,
            cena: selectedMailingLists.users.replace(" RSD", ""),
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Greška pri dodavanju paketa");
      }

      const result = await response.json();
      alert("Paket uspešno dodat");
      window.location.reload();
      handleClose();
    } catch (error) {
      console.error("Greška prilikom dodavanja paketa:", error);
    }
  };

  return (
    <div className="">
      {/* Dugme za otvaranje modala */}
      <button
        onClick={() => setAddNewPretplataModal(true)}
        className="rounded bg-blue-600 px-2 py-1 h-8 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
      >
        Kreiraj novu pretplatu
      </button>

      {/* Modal */}
      <Transition show={addNewPretplataModal}>
        <Dialog onClose={handleClose} className="relative z-50">
          <div className="fixed inset-0 bg-black/30" aria-hidden="true" />

          <div className="fixed inset-0 flex items-center justify-center p-4">
            <Dialog.Panel className="w-full max-w-md bg-white p-6 rounded-lg shadow-lg">
              <Dialog.Title className="text-lg font-semibold">
                Odaberi tip pretplate
              </Dialog.Title>

              {/* Select za odabir vrste pretplate */}
              <select
                className="mt-4 w-full p-2 border rounded-md"
                value={selectedOption}
                onChange={(e) => {
                  setSelectedOption(e.target.value);
                  setSelectedMailingLists(null);
                }}
              >
                <option value="">Izaberi opciju</option>
                <option value="Mesečni">Mesečni</option>
                <option value="Godišnji">Godišnji</option>
              </select>

              {/* Prikazivanje dodatnog sadržaja nakon odabira */}
              {selectedOption && (
                <fieldset className="mt-3">
                  <legend className="text-sm font-semibold text-gray-900">
                    Odaberi paket
                  </legend>
                  <RadioGroup
                    value={selectedMailingLists}
                    onChange={setSelectedMailingLists}
                    className="mt-4 grid grid-cols-1 gap-y-4 sm:grid-cols-2 sm:gap-x-4"
                  >
                    {getMailingLists().map((mailingList) => (
                      <Radio
                        key={mailingList.id}
                        value={mailingList}
                        className="group relative flex cursor-pointer rounded-lg border border-gray-300 bg-white p-4 shadow-sm focus:outline-none data-[focus]:border-green-600 data-[focus]:ring-2 data-[focus]:ring-green-600"
                      >
                        <span className="flex flex-1">
                          <span className="flex flex-col">
                            <span className="block text-sm font-medium text-gray-900">
                              {mailingList.title}
                            </span>
                            <span className="mt-1 flex items-center text-sm text-gray-500">
                              {mailingList.description
                                .split("\n")
                                .map((line, index) => (
                                  <React.Fragment key={index}>
                                    {line}
                                    <br />
                                  </React.Fragment>
                                ))}
                            </span>
                            <span className="mt-6 text-sm font-medium text-gray-900">
                              {mailingList.users}
                            </span>
                          </span>
                        </span>
                        <CheckCircleIcon
                          aria-hidden="true"
                          className="size-5 text-green-600 group-[&:not([data-checked])]:invisible"
                        />
                      </Radio>
                    ))}
                  </RadioGroup>
                </fieldset>
              )}

              {/* Dugmad za akcije */}
              <div className="mt-6 flex justify-between">
                <button
                  onClick={handleClose}
                  className="px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700"
                >
                  Zatvori
                </button>
                {selectedMailingLists && selectedOption && (
                  <button
                    className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700"
                    onClick={addPaket}
                  >
                    Izaberi
                  </button>
                )}
              </div>
            </Dialog.Panel>
          </div>
        </Dialog>
      </Transition>
    </div>
  );
}
